import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LockKey, CheckCircle } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (!token) toast.error("Geçersiz sıfırlama bağlantısı");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 10) return toast.error("Şifre en az 10 karakter olmalı (harf + rakam)");
    if (password !== confirm) return toast.error("Şifreler eşleşmiyor");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      toast.success("Şifreniz güncellendi");
      setTimeout(() => nav("/login"), 2000);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Sıfırlama başarısız");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="w-full max-w-md rounded-sm border-border">
        <CardContent className="p-8">
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-2">
            Otopark Yönetim
          </div>
          <h2 className="text-3xl font-bold tracking-tight mb-6">Yeni Şifre Belirle</h2>

          {done ? (
            <div className="space-y-4 text-center py-6">
              <CheckCircle size={48} weight="fill" className="text-primary mx-auto" />
              <p className="text-sm text-muted-foreground" data-testid="reset-success-msg">
                Şifreniz başarıyla güncellendi. Yönlendiriliyorsunuz...
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="new-password">
                  <LockKey size={14} className="inline mr-1" /> Yeni Şifre
                </Label>
                <Input
                  id="new-password"
                  type="password"
                  data-testid="reset-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1.5 rounded-sm"
                  required
                  minLength={6}
                />
              </div>
              <div>
                <Label htmlFor="confirm">Yeni Şifre (Tekrar)</Label>
                <Input
                  id="confirm"
                  type="password"
                  data-testid="reset-confirm-input"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="mt-1.5 rounded-sm"
                  required
                  minLength={6}
                />
              </div>
              <Button
                type="submit"
                disabled={loading || !token}
                data-testid="reset-submit-btn"
                className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 font-semibold uppercase tracking-widest"
              >
                {loading ? "Kaydediliyor..." : "Şifreyi Güncelle"}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
